import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { titleControl } from "@/utils";
if (!window.VueRouter) {
  Vue.use(VueRouter);
}

const router = new VueRouter({
  mode: "history",
  routes,
});
router.afterEach((to, from) => {
  if (to.meta.title) {
    titleControl.setRouterTitle(to.meta.title);
  }
});

export default router;
